import de from '@vueform/vueform/locales/de'
import en from '@vueform/vueform/locales/en'
import { prefix as tailwind } from '@vueform/vueform/dist/tailwind'
import { defineConfig, Validator } from '@vueform/vueform'
import AccordionElement from './resources/js/components/AccordionElement.vue'
import CFormSteps from './resources/js/components/CustomFormSteps.vue'
import CFormStep from './resources/js/components/CustomFormStep.vue'
import CFormStepsControl from './resources/js/components/CustomFormStepsControl.vue'

const TailwindPrefix = 'tw-' // it should be 'vf-' but the vueform developers hardcoded 'tw-' for some reason in 1.11.0

export { TailwindPrefix }

const customvalidation = class extends Validator {

  get isAsync() {
    return true
  }

  get msg() {
    return this.messageFromEndpoint;  
  }

  get customname () {
    return this.attributes[0] || 'none'
  }

  async check(value) {
    this.messageFromEndpoint = '';
    try {
      const appUrl = process.env.MIX_APP_URL;
      const validationUrl = appUrl + (appUrl.endsWith('/') ? '' : '/') + 'api/form/customValidate';
      const response = await axios.post(validationUrl, {  
        value:      value,
        validator:  this.customname,
        module:     window.module,
      });
      
      if (response.data.success) {  
        return true;  
      }  
      this.messageFromEndpoint = response.data.message;  
      return false;  
    } catch (error) {
      this.messageFromEndpoint = 'Validierung konnte nicht durchgeführt werden. Bitte später erneut versuchen.';  
      return false;  
    }

  }

}

export default defineConfig({
  rules: {
    customvalidation,
  },
  theme: tailwind(TailwindPrefix),
  locales: { de, en },
  locale: 'de',

  elements: [
    AccordionElement,
  ],
  templates: {
    ObjectElement_accordion: AccordionElement,
    FormSteps_demo: CFormSteps,
    FormStep_demo: CFormStep,
    FormStepsControl_demo: CFormStepsControl,
  },

  /**
   * If classHelpers is enabled, the view shows the corresponding object names
   * https://vueform.com/docs/styles-and-layout#class-helpers
   *
   * If instead the variables like "--tw-primary" vueform uses needs to be changed,
   * this would need to happen in a css file that is loaded after app.css.
   * https://vueform.com/themes/tailwind#customization
   */

  // classHelpers: true, // "RadiogroupRadio.container-->" => RadiogroupRadio: { container: 'tailwind classes to add' }

  floatPlaceholders: true,

  addClasses: {
    RadiogroupElement: {
      wrapper: 'tw-form-radio-inline-block',
      container: 'tw-form-radio-type',
    },
    RadiogroupRadio: {
      container: 'tw-form-radio-inline-block',
    },
    ElementLabel: {
      container: 'tw-font-bold',
    },
    CheckboxgroupElement: {
      container: 'tw-form-checkbox-type',
    },
    GroupElement: {
      container: 'tw-form-group-type',
    }
  },

  removeClasses: {
    FilePreview: {
      remove: 'tw-form-hidden'
    },
    SignatureElement: {
      pad_invert: 'tw-filter dark:tw-invert',
      color_invert: 'dark:filterdark:tw-invert'
    }
  }
})
